import React from 'react';
import PropTypes from 'prop-types';

import './StoriesNavigationButton.less';

const StoriesNavigationButton = ({ direction, label, onTouchStart, onTouchEnd }) => (
  <button
    className={`zostories__navigate zostories__navigate--${direction}`}
    aria-label={direction}
    data-action={direction}
    onTouchStart={onTouchStart}
    onTouchEnd={onTouchEnd}
  >
    {label}
  </button>
);

StoriesNavigationButton.propTypes = {
  direction: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onTouchStart: PropTypes.func,
  onTouchEnd: PropTypes.func,
};

export default StoriesNavigationButton;



// WEBPACK FOOTER //
// ./src/components/onboard/Stories/StoriesNavigationButton/StoriesNavigationButton.jsx